export const ACCEPT_COOKIE = "IS_ACCEPT_COOKIE";
